export const state = () => ({
  isOpen: false
})

export const getters = {
  isOpen: state => state.isOpen
}

export const mutations = {
  SET_IS_OPEN(state, isOpen) {
    state.isOpen = isOpen
  },
  RESET(state) {
    state.isOpen = false
  }
}

export const actions = {}
